import PSDropZone from './PSDropZone';
import PSAudio from './PSAudio';

export const PS = {
    DropZone: PSDropZone,
    Audio: PSAudio,
};
